import React from "react";
import _ from "lodash";
import { Div, Image, Text, StyleReset } from "atomize";
import { Link } from "gatsby";
import CustomContainer from "../common/CustomContainer";
import WebsiteContainer from "../common/WebsiteContainer";
import Swiper from "react-id-swiper";
import ImageLink from "../common/ImageLink";
import { IsValidUrl } from "../../utilities/helpers";

const params = {
  slidesPerView: "auto",
  spaceBetween: 15,
  autoHeight: true,
  slidesOffsetAfter: 60,
  mousewheel: {
    forceToAxis: true,
    invert: true,
  },
  // breakpoints: {
  //   1920: {
  //     slidesPerView: 6.2,
  //     spaceBetween: 20,
  //   },
  //   1400: {
  //     slidesPerView: 6.75,
  //     spaceBetween: 16,
  //   },
  //   1200: {
  //     slidesPerView: 6.2,
  //     spaceBetween: 16,
  //   },
  //   1024: {
  //     slidesPerView: 3.8,
  //     spaceBetween: 16,
  //   },
  //   768: {
  //     slidesPerView: 3.8,
  //     spaceBetween: 16,
  //   },
  //   640: {
  //     slidesPerView: 1.5,
  //     spaceBetween: 16,
  //   },
  //   320: {
  //     slidesPerView: 1.5,
  //     spaceBetween: 16,
  //   },
  // },
};

const PricingSlider = ({ title, items }) => (
  <Div>
    <WebsiteContainer>
      <CustomContainer>
        <Text
          maxW="34rem"
          textSize={{ xs: "caption4", md: "subheader3" }}
          textAlign={{ xs: "center", md: "left" }}
          textWeight="600"
          m={{ xs: " 2rem 0", md: "2.3rem 0" }}
          tag="h2"
        >
          {title}
        </Text>
      </CustomContainer>
    </WebsiteContainer>
    <Div className="pricing-brand-swiper" maxW="68.75rem" m="auto">
      <Swiper {...params}>
        {items.map((item, index) => {
          return (
            <div>
              <Div bg="white" overflow="hidden">
                <ImageLink link={_.get(item, "image.description")}>
                  <Div
                    bgImg={_.get(item, "image.file.url")}
                    bgSize="cover"
                    bgPos="center"
                    p={{ b: "100%" }}
                  ></Div>
                </ImageLink>
                <Div p="0.8rem 1rem" d="flex" justify="center">
                  <ImageLink link={item.logo.description}>
                    <Image
                      alt={item.logo.description && item.logo.description}
                      w="auto"
                      h="1.5rem"
                      src={item.logo.file.url}
                    />
                  </ImageLink>
                </Div>
              </Div>
            </div>
          );
        })}
      </Swiper>
    </Div>
  </Div>
);

export default PricingSlider;
